import { DraggableProvided } from '@hello-pangea/dnd';

/**
 * Pins a @hello-pangea/dnd draggable to its column (vertical-only drag).
 * The lib has no axis lock, so we rewrite the drag transform's x to 0: the row
 * tracks the cursor vertically but stays in its column even when the cursor
 * wanders sideways. A no-op while resting (the x offset is already 0 then).
 * @param provided The DraggableProvided from a @hello-pangea/dnd render prop.
 * @returns A DraggableProvided with the horizontal translate zeroed.
 */
export const lockDragAndDropHorizontalAxis = (
  provided: DraggableProvided,
): DraggableProvided => {
  const { style } = provided.draggableProps;
  if (!style?.transform) {
    return provided;
  }
  // transform is `translate(Xpx, Ypx)`; the second part (` Ypx)`) still carries
  // the closing paren, so we re-emit it after pinning X to 0.
  const [, verticalOffset] = style.transform.split(',');
  return {
    ...provided,
    draggableProps: {
      ...provided.draggableProps,
      style: { ...style, transform: `translate(0px,${verticalOffset}` },
    },
  };
};
